export default {
  "feeds_review_about": {
    "HK": "關於",
    "TW": "關於",
    "ar_SA": "حول",
    "de_DE": "Details",
    "en_US": "About",
    "es_ES": "Información",
    "fr_FR": "À propos",
    "hi_IN": "About",
    "in_ID": "pengantar",
    "ja_JP": "About",
    "ko_KR": "About",
    "ms_MY": "Pengenalan",
    "pt_PT": "Sobre",
    "ru_RU": "Описание",
    "th_TH": "เกี่ยวกับ",
    "tr_TR": "Hakkında",
    "ur": "تعارف",
    "uz": "Haqida",
    "vi_VN": "Giới thiệu",
    "zh_CN": "关于"
  },
  "feeds_review_check": {
    "HK": "審核",
    "TW": "審核",
    "ar_SA": "مراجعة",
    "de_DE": "Überprüfen",
    "en_US": "Check",
    "es_ES": "Verificar",
    "fr_FR": "Vérifier",
    "hi_IN": "Check",
    "in_ID": "Tinjauan",
    "ja_JP": "Check",
    "ko_KR": "Check",
    "ms_MY": "Semakan",
    "pt_PT": "Verificar",
    "ru_RU": "Обзор",
    "th_TH": "ตรวจสอบ",
    "tr_TR": "İncele",
    "ur": "چیک کریں",
    "uz": "Tekshirish",
    "vi_VN": "Xét Duyệt",
    "zh_CN": "审核"
  },
  "feeds_review_confirm": {
    "HK": "確認",
    "TW": "確定",
    "ar_SA": "تأكيد",
    "de_DE": "Bestätigen",
    "en_US": "Confirm",
    "es_ES": "Aceptar",
    "fr_FR": "Confirmer",
    "hi_IN": "Confirm",
    "in_ID": "Mengonfirmasi",
    "ja_JP": "Confirm",
    "ko_KR": "Confirm",
    "ms_MY": "Sahkan",
    "pt_PT": "Confirmar",
    "ru_RU": "Подтвердить",
    "th_TH": "ยืนยัน",
    "tr_TR": "Onayla",
    "ur": "تصدیق کریں",
    "uz": "Tasdiqlash",
    "vi_VN": "Đồng ý",
    "zh_CN": "确认"
  },
  "feeds_review_error_msg": {
    "HK": "提交失敗，請重試",
    "TW": "提交失敗，請重試",
    "ar_SA": "تعذر الإرسال! يُرجى المحاولة مجددًا",
    "de_DE": "Falsch! Bitte versuche es erneut.",
    "en_US": "Wrong! Please try again",
    "es_ES": "¡Error! Inténtalo de nuevo",
    "fr_FR": "Échec. Réessayez",
    "hi_IN": "Wrong! Please try again",
    "in_ID": "Pengiriman gagal. Silakan coba lagi",
    "ja_JP": "Wrong! Please try again",
    "ko_KR": "Wrong! Please try again",
    "ms_MY": "Gagal diserahkan. Sila cuba semula",
    "pt_PT": "Errado! Tente novamente",
    "ru_RU": "Отправка прервана! Повторите попытку позже.",
    "th_TH": "การส่งล้มเหลว! กรุณาลองอีกครั้ง",
    "tr_TR": "Gönderme başarısız! Lütfen tekrar dene",
    "ur": "غلط! براہ کرم دوبارہ کوشش کریں",
    "uz": "Xato! Qayta urining",
    "vi_VN": "Gửi thất bại! Hãy thử lại",
    "zh_CN": "提交失败，请重试"
  },
  "feeds_review_finish": {
    "HK": "完成",
    "TW": "完成",
    "ar_SA": "المظهر",
    "de_DE": "Beenden",
    "en_US": "Finish",
    "es_ES": "Terminar",
    "fr_FR": "Terminer",
    "hi_IN": "Finish",
    "in_ID": "Selesai",
    "ja_JP": "Finish",
    "ko_KR": "Finish",
    "ms_MY": "Selesai",
    "pt_PT": "Acabamento",
    "ru_RU": "Раскраска",
    "th_TH": "สำเร็จ",
    "tr_TR": "Bitir",
    "ur": "اختتام کریں",
    "uz": "Yakunlash",
    "vi_VN": "Hoàn Thành",
    "zh_CN": "完成"
  },
  "feeds_review_integral": {
    "HK": "積分",
    "TW": "積分",
    "ar_SA": "النقاط",
    "de_DE": "Integrität",
    "en_US": "Integral",
    "es_ES": "Integral",
    "fr_FR": "Intégral",
    "hi_IN": "Integral",
    "in_ID": "mata",
    "ja_JP": "Integral",
    "ko_KR": "Integral",
    "ms_MY": "Mata",
    "pt_PT": "Integral",
    "ru_RU": "Очки",
    "th_TH": "คะแนน",
    "tr_TR": "Puan",
    "ur": "لازمی",
    "uz": "Integral",
    "vi_VN": "Điểm",
    "zh_CN": "积分"
  },
  "feeds_review_me": {
    "HK": "我的",
    "TW": "我的",
    "ar_SA": "أنا",
    "de_DE": "Ich",
    "en_US": "Me",
    "es_ES": "Yo",
    "fr_FR": "Moi",
    "hi_IN": "Me",
    "in_ID": "saya",
    "ja_JP": "Me",
    "ko_KR": "Me",
    "ms_MY": "Saya",
    "pt_PT": "Eu",
    "ru_RU": "Я",
    "th_TH": "ฉัน",
    "tr_TR": "Ben",
    "ur": "میں",
    "uz": "Men",
    "vi_VN": "Tôi",
    "zh_CN": "我的"
  },
  "feeds_review_name": {
    "HK": "暱稱",
    "TW": "暱稱",
    "ar_SA": "الاسم",
    "de_DE": "Name",
    "en_US": "Name",
    "es_ES": "Nombre",
    "fr_FR": "Nom",
    "hi_IN": "Name",
    "in_ID": "Nama",
    "ja_JP": "Name",
    "ko_KR": "Name",
    "ms_MY": "Nama",
    "pt_PT": "Nome",
    "ru_RU": "Имя",
    "th_TH": "ชื่อ",
    "tr_TR": "İsim",
    "ur": "نام",
    "uz": "Ism",
    "vi_VN": "Tên Hiệu",
    "zh_CN": "昵称"
  },
  "feeds_review_no_category": {
    "HK": "無分類",
    "TW": "無分類",
    "ar_SA": "لا توجد فئة",
    "de_DE": "Keine Kategorie",
    "en_US": "No category",
    "es_ES": "Sin categoría",
    "fr_FR": "Aucune catégorie",
    "hi_IN": "No category",
    "in_ID": "Tidak ada kategori",
    "ja_JP": "No category",
    "ko_KR": "No category",
    "ms_MY": "Tiada kategori",
    "pt_PT": "Nenhuma categoria",
    "ru_RU": "Нет категории",
    "th_TH": "ไม่มีหมวดหมู่",
    "tr_TR": "Kategori yok",
    "ur": "کوئی زمرہ نہیں",
    "uz": "Turkumsiz",
    "vi_VN": "Không phân loại",
    "zh_CN": "无分类"
  },
  "feeds_review_report": {
    "HK": "舉報",
    "TW": "檢舉",
    "ar_SA": "إبلاغ",
    "de_DE": "Report",
    "en_US": "Report",
    "es_ES": "Denunciar",
    "fr_FR": "Signaler",
    "hi_IN": "Report",
    "in_ID": "Laporkan itu",
    "ja_JP": "Report",
    "ko_KR": "Report",
    "ms_MY": "Laporkan",
    "pt_PT": "Denunciar",
    "ru_RU": "Отчет",
    "th_TH": "รายงาน",
    "tr_TR": "Rapor",
    "ur": "‏رپورٹ",
    "uz": "Shikoyat",
    "vi_VN": "Tố cáo",
    "zh_CN": "举报"
  },
  "feeds_review_select": {
    "HK": "請選擇分類",
    "TW": "請選擇分類",
    "ar_SA": "يُرجى تحديد فئة",
    "de_DE": "Bitte wähle eine Kategorie",
    "en_US": "Please select a category",
    "es_ES": "Selecciona una categoría",
    "fr_FR": "Choisissez une catégorie",
    "hi_IN": "Please select a category",
    "in_ID": "Silakan pilih kategori",
    "ja_JP": "Please select a category",
    "ko_KR": "Please select a category",
    "ms_MY": "Sila pilih kategori",
    "pt_PT": "Selecione uma categoria",
    "ru_RU": "Выберите категорию.",
    "th_TH": "กรุณาเลือกหมวดหมู่",
    "tr_TR": "Lütfen bir kategori seç",
    "ur": "براہ کرم کوئی زمرہ منتخب کریں",
    "uz": "Turkumni tanlang",
    "vi_VN": "Hãy chọn một loại.",
    "zh_CN": "请选择分类"
  },
  "feeds_review_title": {
    "HK": "內容審核",
    "TW": "內容審核",
    "ar_SA": "مراجعة المحتوى",
    "de_DE": "Inhaltskontrolle",
    "en_US": "Content check",
    "es_ES": "Verificación de contenido",
    "fr_FR": "Vérification de contenu",
    "hi_IN": "Content check",
    "in_ID": "Tinjauan Konten",
    "ja_JP": "Content check",
    "ko_KR": "Content check",
    "ms_MY": "Semakan Kandungan",
    "pt_PT": "Verificação de conteúdo",
    "ru_RU": "Обзор контента",
    "th_TH": "ตรวจสอบเนื้อหา",
    "tr_TR": "İçerik İnceleme",
    "ur": "مواد کا چیک",
    "uz": "Kontentni tekshirish",
    "vi_VN": "Xét Duyệt Nội Dung",
    "zh_CN": "审核模块"
  },
  "feeds_review_today": {
    "HK": "今日成就",
    "TW": "今日成就",
    "ar_SA": "إنجازات اليوم",
    "de_DE": "Heutige Achievements",
    "en_US": "Achievements Today",
    "es_ES": "Logros de hoy",
    "fr_FR": "Succès aujourd'hui",
    "hi_IN": "Achievements Today",
    "in_ID": "Prestasi hari ini",
    "ja_JP": "Achievements Today",
    "ko_KR": "Achievements Today",
    "ms_MY": "Pencapaian Hari Ini",
    "pt_PT": "Conquistas Hoje",
    "ru_RU": "Достижения дня",
    "th_TH": "ความสำเร็จวันนี้",
    "tr_TR": "Bugünkü Başarımlar",
    "ur": "آج کی کامیابیاں",
    "uz": "Bugungi yutuqlar",
    "vi_VN": "Thành Tích Hôm Nay",
    "zh_CN": "今日成就"
  },
  "feeds_review_total": {
    "HK": "總計",
    "TW": "總計",
    "ar_SA": "الإجمالي",
    "de_DE": "Gesamt",
    "en_US": "Total",
    "es_ES": "Total",
    "fr_FR": "Total",
    "hi_IN": "Total",
    "in_ID": "Jumlah",
    "ja_JP": "Total",
    "ko_KR": "Total",
    "ms_MY": "Jumlah",
    "pt_PT": "Total",
    "ru_RU": "Всего",
    "th_TH": "รวม",
    "tr_TR": "Toplam",
    "ur": "‏کُل",
    "uz": "Jami",
    "vi_VN": "Tổng cộng",
    "zh_CN": "总计"
  },
  "feeds_review_winning": {
    "HK": "準確率",
    "TW": "準確率",
    "ar_SA": "الدقة",
    "de_DE": "Gewinnen",
    "en_US": "Winning",
    "es_ES": "Victorias",
    "fr_FR": "Victoire",
    "hi_IN": "Winning",
    "in_ID": "Ketepatan",
    "ja_JP": "Winning",
    "ko_KR": "Winning",
    "ms_MY": "Ketepatan",
    "pt_PT": "Vitória",
    "ru_RU": "Точность",
    "th_TH": "ความแม่นยำ",
    "tr_TR": "İsabet",
    "ur": "جیتنا",
    "uz": "Gʻalaba",
    "vi_VN": "Độ chính xác",
    "zh_CN": "准确率"
  }
}